import { render, staticRenderFns } from "./ManageCoupon.vue?vue&type=template&id=0fc14899&"
import script from "./ManageCoupon.vue?vue&type=script&lang=js&"
export * from "./ManageCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports